/**
 * URL building utilities
 */

/** Build query string from object */
export function buildQueryString(params: Record<string, string | string[] | undefined>): string {
  const parts: string[] = [];
  
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === '') continue;
    
    if (Array.isArray(value)) {
      if (value.length > 0) {
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value.join(','))}`);
      }
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  }
  
  return parts.join('&');
}

/** Build a share URL with query parameters */
export function buildShareUrl(baseUrl: string, params: Record<string, string | string[] | undefined>): string {
  const queryString = buildQueryString(params);
  if (!queryString) return baseUrl;
  
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${queryString}`;
}

/** Ensure URL has protocol */
export function ensureProtocol(url: string): string {
  if (!url) return url;
  if (url.startsWith('//')) return `https:${url}`;
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }
  return url;
}

